import Panel from 'beam/dist/Panel'
import { WandIcon } from '../../ApplicationManagement/Analytics/PhraseManager/PhraseManagerIcons'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import { CircularProgress, Theme, Grid } from '@mui/material'
import { Fragment, useEffect, useState, useRef } from 'react'
import { getInteractionSummary, getOverallSentiment } from './api'

import { useAuthenticatedUser } from '../../../Permissions'
import * as PAGE_PERMISSIONS from '../../../Permissions/pagePermissions.constants'
import { Tabs } from 'beam/dist/Tabs'
import Tab from '@mui/material/Tab'
import { useFeatureFlagValue } from '../../../FeatureFlags'
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlags.constants'
import noDataBg from '../../../Assets/empty-img-default.svg'
import noDataBgText from '../../../Assets/empty-no-data-text.svg'
export const dataTestIdPrefix = 'MediaPlayerWorkspace-InteractionSummarization-'
import { useAppSelector } from '../../../root.reducer'

import Sentiment from '../const/sentiment'
import { DATA_INSIGHTS_TAB_INTERACTION_SUMMARY, DATA_INSIGHTS_TAB_AI_ANALYTICS, InteractionSummaryProps, SentimentData } from './interactionsummary.constants'
import _ from 'lodash'


const useStyles = makeStyles((theme: Theme) => ({
  summaryPanel: {
    marginBottom: `${theme.spacing(1)} !important`,
  },
  root: {
    padding: '8px 16px 16px 16px',
    maxHeight: '215px',
    display: 'flex',
    flexDirection: 'column',
  },
  rootNew: {
    padding: '8px 16px 16px 16px',
    maxHeight: '245px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  loadingContainer: {
    padding: theme.spacing(2),
    width: '96%',
    height: '215px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  summaryContainer: {
    background: '#EFEEF7',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    overflow: 'auto',
    height: '100%',
    width: '96%',
    fontSize: '14px',
    lineHeight: '18px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
  },
  summaryContainerNew: {
    background: '#EFEEF7',
    padding: '8px 8px 16px 16px',
    borderRadius: theme.spacing(0.5),
    overflow: 'auto',
    // height: '100%',
    width: '100%',
    fontSize: '14px',
    lineHeight: '18px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
  },
  summaryText: {
    order: 1,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    margin: 0,
    padding: 0,
    paddingRight: theme.spacing(3),
    '& p': {
      padding: 0,
      margin: 0,
    },
  },
  summaryTextNew: {
    order: 1,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    margin: 0,
    padding: 0,
    paddingRight: theme.spacing(3),
    '& p': {
      padding: 0,
      margin: 0,
    },
    gap: '8px',
  },
  copyContainer: {
    order: 2,
    position: 'sticky',
    alignSelf: 'flex-start',
    top: 0,
    right: 0,
  },
  tabRoot: {
    color: 'black',
    '& .Mui-selected': {
      color: '#006FE7',
    },
    '& .MuiButtonBase-root': {
      opacity: 1,
      padding: '12px 0px',
      margin: '0px 16px 0px 0px',
    },
    '& .MuiButtonBase-root span.MuiTouchRipple-root': {
      display: 'none',
    },
  },
  tabIndicator: {
    backgroundColor: '#006FE7 !important',
    height: '2px',
  },
  tabTitle: {
    fontSize: '15px',
  },
  tabSubTitle: {
    fontSize: '12px',
    fontWeight: 400,
  },
  showIframe: {
    display: 'block',
  },
  showEmpty: {
    display: 'block',
    height: '215px',
  },
  hideIframe: {
    display: 'none',
  },
  aiInteractionAnalysisWrapper: {
    width: '100%',
    maxHeight: '170px',
    minHeight: '170px',
    display: 'flex',
    gap: '8px',
  },
  aiSentimentAnalysisContainer: {
    display: 'flex',
    minWidth: '344px',
    overflow: 'auto',
    padding: '8px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    background: 'rgba(217, 217, 217, 0.20)',
    flexGrow: 1,
  },
  aiSentimentAnalysisContent: {
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  aiSentimentAnalysisContentTitle: {
    alignSelf: 'stretch',
    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '22px',
  },
  aiSentimentAnalysisContentBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  aiInteractionSummaryTitle: {
    alignSelf: 'stretch',
    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '22px',
  },
  aiInteractionSummaryBody: {
    alignSelf: 'stretch',
    color: '#1B1F22',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
  },
  noDataBg: {
    width: '100%',
    height: '100%',
    flexShrink: '0',
    background: `url(${noDataBg}) no-repeat center`,
  },
  noDataBgText: {
    width: '100%',
    height: '100%',
    flexShrink: '0',
    background: `url(${noDataBgText}) no-repeat center`,
  },
  sentimentNegative: {
    borderRadius: '3.125px',
    background: '#FCEAEA !important',
    color: '#E22828 !important',
  },
  sentimentNetural: {
    borderRadius: '3.125px',
    background: '#ECEEF0 !important',
    color: '#003D80 !important',
  },
  sentimentPositive: {
    borderRadius: '3.125px',
    background: '#E1F5EF !important',
    color: '#1A8562 !important',
  },
  sentimentSubTitle: {
    display: 'flex',
    padding: '0px 8px',
    alignItems: 'flex-start',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '15.625px',
  },
  sentimentSubBody: {
    maxWidth: '315px',
    minHeight: '33px',
    alignSelf: 'stretch',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: 'normal',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  aiInteractionSummaryNoData: {
    paddingRight: '15px',
  },
  aiSentimentAnalysisContentNoData: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: 'normal',
    overflow: 'hidden',
    textAlign: 'center',
  },
}))


export const InteractionSummary: React.FC<InteractionSummaryProps> = ({ clientAppId, ccrId, autoQAHasData, autoQAReloadTimestamp, autoQAFormId }) => {
  const [loading, setLoading] = useState(true)
  const [summary, setSummary] = useState<string | null>(null)
  const [tabValue, setTabValue] = useState(DATA_INSIGHTS_TAB_INTERACTION_SUMMARY)
  const [sentimentData, setSentimentData] = useState<SentimentData | null>(null)
  const [sentimentLoading, setSentimentLoading] = useState(true)
  const translationOverallSentimentKey = {
    [Sentiment.state.NEGATIVE]: 'negative',
    [Sentiment.state.NEUTRAL]: 'neutral',
    [Sentiment.state.POSITIVE]: 'positive',
    [Sentiment.state.UNSCORED]: 'unscored',
  } as const

  const { t } = useTranslation()
  const classes = useStyles()

  const [open, setOpen] = useState(false)
  const [copied, setCopied] = useState(false)

  const iframeRef = useRef<HTMLIFrameElement>(null)

  const convIntelligenceWebUrl = useAppSelector(state => state.app.appProperties?.convIntelligenceWebUrl)
  const authHost = window.location.host

  const authenticatedUser = useAuthenticatedUser()
  const { user, hasAnyPermission } = authenticatedUser
  const sessionId = user?.sessionId
  const iframeUrl = convIntelligenceWebUrl ? `${convIntelligenceWebUrl}/#/autoQA/aiEvaluationSummary/?host=${authHost}&sid=${sessionId}&contactId=${ccrId}` : null
  const hasAutoQAPermission = hasAnyPermission(PAGE_PERMISSIONS.AUTO_QA_INTERACTION)
  const hasTrendingTopicPermission = hasAnyPermission(PAGE_PERMISSIONS.TRENDING_TOPICS)
  const hasSentimentViewPermission = hasAnyPermission(PAGE_PERMISSIONS.SENTIMENT_VIEW)
  const hasSmartTagViewPermission = hasAnyPermission(PAGE_PERMISSIONS.SMART_TAGS)
  const summaryEnabled = useFeatureFlagValue('analytics.enable-interaction-summarization')
  const isAdvancedSentimentEnabled = useFeatureFlagValue(FEATURE_FLAGS.ANALYTICS_ENABLE_ADVANCED_SENTIMENT)
  const isSmartTagEnabled = useFeatureFlagValue(FEATURE_FLAGS.ANALYTICS_ENABLE_SMART_TAG)

  const isAiAnalysisTabVisible = hasAutoQAPermission || hasTrendingTopicPermission || (isSmartTagEnabled && hasSmartTagViewPermission)
  const isInteractionSummaryVisible = summaryEnabled
  const isSentimentTrendsVisible = hasSentimentViewPermission
  const isInteractiveInSightsTabVisible = isInteractionSummaryVisible || isSentimentTrendsVisible

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    if (copied) {
      setCopied(false)
    }
  }

  const handleCopy = () => {
    if (!copied) {
      setCopied(true)
    }
    navigator.clipboard.writeText(summary ?? '')
  }

  const resetSummaryAndTabValue = () => {
    setSummary(null)
    setTabValue(DATA_INSIGHTS_TAB_AI_ANALYTICS)
  }

  const  renderLoading = (classes: string) => (
    <>
      <div className={classes}>
        <CircularProgress />
      </div>
    </>
  )

  const  renderSummaryNoData = () => (
    <>
      <div className={`${classes.noDataContainer} ${classes.noDataBgText}`}>
        <span className={classes.aiInteractionSummaryTitle}>{t('dataInsightsInteractSummaryTitle')}</span>
        <span className={classes.aiInteractionSummaryNoData}>{t('dataInsightsInteractSummaryNoDataText')}</span>
      </div>
    </>
  )

  const  renderSummnaryContent = () => (
    <>
      <div className={classes.copyContainer}>
        <Tooltip
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
          title={copied ? t('copiedToClipboard') : t('copy')}
        >
          <IconButton
            onClick={handleCopy}
            data-testid={dataTestIdPrefix + 'Panel-Summary-CopyButton'}
          >
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.summaryTextNew} data-testid={dataTestIdPrefix + 'Panel-Summary-Content'}>
        <span className={classes.aiInteractionSummaryTitle}>{t('dataInsightsInteractSummaryTitle')}</span>
        <span className={classes.aiInteractionSummaryBody}>
          {summary}
        </span>
      </div>
    </>
  )

  const  renderSentimentNoData = () => (
    <>
      <div className={`${classes.noDataContainer} ${classes.noDataBg}`}>
        <span className={classes.aiSentimentAnalysisContentTitle}>{t('dataInsightsAISentimentAnalysisTitle')}</span>
        <span className={classes.aiSentimentAnalysisContentNoData}>{t('dataInsightsAISentimentAnalysisNoDataText')}</span>
      </div>
    </>
  )

  const  renderSentimentContent = () => (
    <>
      <div className={`${classes.aiSentimentAnalysisContent}`}>
        <div className={classes.aiSentimentAnalysisContentTitle}>{t('dataInsightsAISentimentAnalysisTitle')}</div>
        <div className={classes.aiSentimentAnalysisContentBody}>
          {(typeof sentimentData?.overallUserSentiment === 'number') && !isNaN(sentimentData?.overallUserSentiment) && (
            <>
              <span className={`${classes.sentimentSubTitle} ${getOverallSentimentClass(sentimentData.overallUserSentiment)}`}>{t(translationOverallSentimentKey[Sentiment.getStateFromScore(sentimentData.overallUserSentiment)]) + ' Customer'}</span>
              <span className={classes.sentimentSubBody}>{sentimentData.overallUserSentimentReason}</span>
            </>
          )}
          {(typeof sentimentData?.overallAgentSentiment === 'number') && !isNaN(sentimentData?.overallAgentSentiment) && (
            <>
              <span className={`${classes.sentimentSubTitle} ${getOverallSentimentClass(sentimentData.overallAgentSentiment)}`}>{t(translationOverallSentimentKey[Sentiment.getStateFromScore(sentimentData.overallAgentSentiment)]) + ' Agent'}</span>
              <span className={classes.sentimentSubBody}>{sentimentData.overallAgentSentimentReason}</span>
            </>
          )}
        </div>
      </div>
    </>
  )

  const getOverallSentimentClass = (sentiment: number) => {
    const sentimentState = Sentiment.getStateFromScore(sentiment)
    switch (sentimentState) {
      case Sentiment.state.NEGATIVE:
        return classes.sentimentNegative
      case Sentiment.state.NEUTRAL:
        return classes.sentimentNetural
      case Sentiment.state.POSITIVE:
        return classes.sentimentPositive
      default:
        return classes.sentimentNetural
    }
  }

  const renderOldLayout = () => (
    <>
      <Grid container item
        className={classes.summaryPanel}
        style={{ 'display': (summary || (isAiAnalysisTabVisible && autoQAHasData)) ? 'inherit' : 'none' }}
      >
        {/* @ts-expect-error TODO: upgrade to beam-v11 */}
        <Panel
          titleIcon={<WandIcon />}
          title={t('dataInsights')}
          dense
          variant={'light'}
          dataTestId={dataTestIdPrefix + 'Panel'}
          headerTestId={dataTestIdPrefix + 'PanelHeader'}
          classes={{ container: classes.title }}
        >
          <div className={classes.root}>
            <Tabs
              onChange={(e, value) => {
                setTabValue(value)
              }}
              value={tabValue}
              classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
            >
              {((summary) && <Tab label={
                <Fragment>
                  <span className={classes.tabTitle}>{t('dataInsightsInteractSummaryTab')}</span>
                </Fragment>
              } value={DATA_INSIGHTS_TAB_INTERACTION_SUMMARY} style={{ textTransform: 'none' }} {...{ 'data-testid': `${dataTestIdPrefix}ai-Interaction-Summary-Tab` }} />)}
              {((isAiAnalysisTabVisible && autoQAHasData) && <Tab label={
                <Fragment>
                  <span className={classes.tabTitle}>{t('dataInsightsAIAnalytics')}
                    <span className = {classes.tabSubTitle}></span>
                  </span>
                </Fragment>
              } value={DATA_INSIGHTS_TAB_AI_ANALYTICS} style={{ textTransform: 'none' }} {...{ 'data-testid': `${dataTestIdPrefix}ai-Analytics-Tab` }} />)}
            </Tabs>

            {tabValue === DATA_INSIGHTS_TAB_INTERACTION_SUMMARY && loading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress />
              </div>
            ) : (tabValue === DATA_INSIGHTS_TAB_INTERACTION_SUMMARY && !loading) && (
              <>
                <div
                  className={classes.summaryContainer}
                  data-testid={dataTestIdPrefix + 'Panel-SummaryContainer'}
                >
                  <div className={classes.copyContainer}>
                    <Tooltip
                      onClose={handleClose}
                      onOpen={handleOpen}
                      open={open}
                      title={copied ? t('copiedToClipboard') : t('copy')}
                    >
                      <IconButton
                        onClick={handleCopy}
                        data-testid={dataTestIdPrefix + 'Panel-Summary-CopyButton'}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div className={classes.summaryText} data-testid={dataTestIdPrefix + 'Panel-Summary-Content'}>
                    {summary}
                  </div>
                </div>
              </>
            )}

            {(isAiAnalysisTabVisible) && (
              <Fragment>
                {iframeUrl
                  ? <iframe ref={iframeRef} className={tabValue === DATA_INSIGHTS_TAB_AI_ANALYTICS ? classes.showIframe : classes.hideIframe} title={t('autoQA')}
                    src={ iframeUrl } width={ '100%' } height={ '100%' } style={ { 'border': 0, visibility: autoQAHasData ? 'visible' : 'hidden' } } />
                  : <div className={tabValue === DATA_INSIGHTS_TAB_AI_ANALYTICS ? classes.showEmpty : classes.hideIframe}></div>
                }
              </Fragment>
            )}
          </div>
        </Panel>
      </Grid>
    </>
  )

  const renderNewLayout = () => (
    <>
      <Grid container item
        className={classes.summaryPanel}
        style={{ 'display': (isInteractiveInSightsTabVisible || (isAiAnalysisTabVisible && autoQAHasData)) ? 'inherit' : 'none' }}
      >
        {/* @ts-expect-error TODO: upgrade to beam-v11 */}
        <Panel
          titleIcon={<WandIcon />}
          title={t('dataInsights')}
          dense
          variant={'light'}
          dataTestId={dataTestIdPrefix + 'Panel'}
          headerTestId={dataTestIdPrefix + 'PanelHeader'}
          classes={{ container: classes.title }}
        >
          <div className={classes.rootNew}>
            <Tabs
              onChange={(e, value) => {
                setTabValue(value)
              }}
              value={tabValue}
              classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
            >
              {((isInteractiveInSightsTabVisible) && <Tab label={
                <Fragment>
                  <span className={classes.tabTitle}>{t('dataInsightsIntSumTab')}</span>
                </Fragment>
              } value={DATA_INSIGHTS_TAB_INTERACTION_SUMMARY} style={{ textTransform: 'none' }} {...{ 'data-testid': `${dataTestIdPrefix}ai-Interaction-Summary-Tab` }} />)}
              {((isAiAnalysisTabVisible && autoQAHasData) && <Tab label={
                <Fragment>
                  <span className={classes.tabTitle}>{t('dataInsightsAIPerformanceTab')}</span>
                </Fragment>
              } value={DATA_INSIGHTS_TAB_AI_ANALYTICS} style={{ textTransform: 'none' }} {...{ 'data-testid': `${dataTestIdPrefix}ai-Analytics-Tab` }} />)}
            </Tabs>
            {(isInteractiveInSightsTabVisible && tabValue === DATA_INSIGHTS_TAB_INTERACTION_SUMMARY) && (
              <>
                <div className={classes.aiInteractionAnalysisWrapper}>
                  {isInteractionSummaryVisible && (
                    <>
                      <div
                        className={classes.summaryContainerNew}
                        data-testid={dataTestIdPrefix + 'Panel-SummaryContainer'}
                      >
                        {((loading && renderLoading(classes.loadingContainer))) ||
                          (!summary && renderSummaryNoData()) ||
                          (summary && renderSummnaryContent())}
                      </div>
                    </>
                  )}
                  {(isSentimentTrendsVisible && sentimentData) && (
                    <>
                      <div className={classes.aiSentimentAnalysisContainer}>
                        {((sentimentLoading && renderLoading(classes.loadingContainer))) ||
                          (!sentimentData && renderSentimentNoData()) ||
                          (sentimentData && renderSentimentContent())}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            {(isAiAnalysisTabVisible) && (
              <Fragment>
                {iframeUrl
                  ? <iframe ref={iframeRef} className={tabValue === DATA_INSIGHTS_TAB_AI_ANALYTICS ? classes.showIframe : classes.hideIframe} title={t('autoQA')}
                    src={ iframeUrl } width={ '100%' } height={ '100%' } style={ { 'border': 0, visibility: autoQAHasData ? 'visible' : 'hidden' } } />
                  : <div className={tabValue === DATA_INSIGHTS_TAB_AI_ANALYTICS ? classes.showEmpty : classes.hideIframe}></div>
                }
              </Fragment>
            )}
          </div>
        </Panel>
      </Grid>
    </>
  )

  useEffect(() => {
    if (!isAdvancedSentimentEnabled) {
      if (!loading) {
        setLoading(true)
      }

      if (!summaryEnabled) {
        resetSummaryAndTabValue()
        return
      }

      getInteractionSummary(clientAppId, ccrId).then(res => {
        if (res.summary) {
          setSummary(res.summary)
        } else {
          resetSummaryAndTabValue()
        }
      }).catch(() => {
        resetSummaryAndTabValue()
      }).finally(() => {
        setLoading(false)
      })
    } else if (isAdvancedSentimentEnabled) {
      if (isInteractiveInSightsTabVisible) {
        if (!loading) {
          setLoading(true)
        }

        getInteractionSummary(clientAppId, ccrId).then(res => {
          if (res.summary) {
            setSummary(res.summary)
          } else {
            setSummary(null)
          }
        }).catch(() => {
          setSummary(null)
        }).finally(() => {
          setLoading(false)
        })

        if (isSentimentTrendsVisible) {
          if (!sentimentLoading) {
            setSentimentLoading(true)
          }
          getOverallSentiment(ccrId).then(res => {
            if (res && res !== null && res !== undefined && !_.isEmpty(res)) {
              setSentimentData(res)
            } else {
              setSentimentData(null)
            }
          }).catch(() => {
            setSentimentData(null)
          }).finally(() => {
            setSentimentLoading(false)
          })
        }
      }
    }

  }, [clientAppId, ccrId])

  useEffect(() => {
    if (autoQAReloadTimestamp > 0) {
      iframeRef?.current?.contentWindow?.postMessage({ channel: 'C1MediaPlayer', action: 'AutoQA.AIAnalysis.reload', formId: autoQAFormId }, '*')
    }
  }, [autoQAReloadTimestamp, autoQAFormId])

  useEffect(() => {
    if (isAdvancedSentimentEnabled) {
      if (isInteractiveInSightsTabVisible) {
        setTabValue(DATA_INSIGHTS_TAB_INTERACTION_SUMMARY)
      } else if (isAiAnalysisTabVisible) {
        setTabValue(DATA_INSIGHTS_TAB_AI_ANALYTICS)
      }
    }
  }, [])

  useEffect(() => {
    if (!autoQAHasData && isAiAnalysisTabVisible && tabValue === DATA_INSIGHTS_TAB_AI_ANALYTICS) {
      if (summaryEnabled) {
        setTabValue(DATA_INSIGHTS_TAB_INTERACTION_SUMMARY)
      }
    }
  }, [autoQAHasData])

  if (!isAdvancedSentimentEnabled) {
    if (!loading && !summary && !isAiAnalysisTabVisible) {
      return null
    }
  } else if (isAdvancedSentimentEnabled) {
    if (!loading && !isInteractiveInSightsTabVisible && !isAiAnalysisTabVisible) {
      return null
    }
  }

  return (
    <>
      {(!isAdvancedSentimentEnabled && renderOldLayout()) ||
        (isAdvancedSentimentEnabled && renderNewLayout())}
    </>
  )
}
